import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import {
    TheSeatEmbedWidget,
    TheSeatEmbedWidgetProps,
} from './TheSeatEmbedWidget'

export const SeatEmbedWidgetRegistration = createRegisterableComponent(
    'election-seat-embed-widget',
    (props: TheSeatEmbedWidgetProps) => {
        return <TheSeatEmbedWidget {...props} />
    },
)
